var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 63,
    viewBox: "0 0 167 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_411_17441)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.717102,
    y: 0.116699,
    width: 166.037,
    height: 62.2639,
    rx: 2.44172,
    fill: "#5AC8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.817 58.729C162.053 59.6303 164.449 60.0942 166.869 60.0942V24.2258C164.449 24.2258 162.053 24.6897 159.817 25.5909C157.581 26.4922 155.55 27.8132 153.838 29.4786C152.127 31.1439 150.77 33.121 149.843 35.2969C148.917 37.4727 148.441 39.8048 148.441 42.16C148.441 44.5151 148.917 46.8472 149.843 49.0231C150.77 51.199 152.127 53.176 153.838 54.8414C155.55 56.5067 157.581 57.8277 159.817 58.729Z",
    fill: "#5856D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.869 24.2258V2.55835C165.407 2.55835 163.96 2.83857 162.609 3.38302C161.259 3.92746 160.031 4.72547 158.998 5.73147C157.964 6.73747 157.144 7.93178 156.584 9.24618C156.025 10.5606 155.737 11.9694 155.737 13.3921C155.737 14.8148 156.025 16.2235 156.584 17.538C157.144 18.8524 157.964 20.0467 158.998 21.0527C160.031 22.0587 161.259 22.8567 162.609 23.4011C163.96 23.9456 165.407 24.2258 166.869 24.2258Z",
    fill: "#5856D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.716888,
    y: 0.116699,
    width: 122.086,
    height: 62.2639,
    fill: "#5856D6"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_411_17441)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_411_17441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.4163 16.8948V11.9127C69.4164 11.2637 69.2887 10.6212 69.0405 10.0216C68.7922 9.42207 68.4283 8.87729 67.9695 8.4184C67.5107 7.95951 66.966 7.59549 66.3665 7.34713C65.767 7.09878 65.1245 6.97095 64.4756 6.97095V15.3152C64.4756 16.6257 64.9961 17.8825 65.9226 18.8092C66.8491 19.7359 68.1058 20.2567 69.4163 20.257V16.8948Z",
    fill: "url(#paint0_linear_411_17441)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.844 15.7097H68.7093C67.6853 15.5671 66.7298 15.1131 65.9725 14.4092C65.2152 13.7053 64.6926 12.7856 64.4756 11.7747V15.7097C64.4756 17.0201 64.9961 18.2769 65.9226 19.2036C66.8491 20.1304 68.1058 20.6511 69.4163 20.6514H75.7886C75.7887 20.0021 75.6609 19.3592 75.4124 18.7594C75.164 18.1596 74.7997 17.6147 74.3405 17.1557C73.8813 16.6968 73.3361 16.3329 72.7361 16.0847C72.1362 15.8366 71.4932 15.7092 70.844 15.7097Z",
    fill: "url(#paint1_linear_411_17441)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.4935 12.1925V8.46606H77.759V11.2183H79.4536V12.1925H76.4935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4588 12.1925L83.0997 8.46606H84.3438L85.9846 12.1925H84.6762L83.4643 9.06229H83.9577L82.7458 12.1925H81.4588ZM82.4348 11.543L82.7565 10.638H84.4832L84.8049 11.543H82.4348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.632 8.46606H91.8975V12.1925H90.632V8.46606ZM89.463 12.1925H88.1975V8.46606H89.463V12.1925ZM90.7178 10.819H89.3772V9.78628H90.7178V10.819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4673 12.2776C95.1742 12.2776 94.9096 12.2315 94.6737 12.1392C94.4377 12.0434 94.2411 11.905 94.0838 11.724L94.7648 10.9255C94.8649 11.0462 94.9632 11.1384 95.0598 11.2023C95.1563 11.2626 95.2564 11.2928 95.3601 11.2928C95.6318 11.2928 95.7676 11.1384 95.7676 10.8297V9.41364H94.4914V8.46606H97.017V10.7551C97.017 11.2662 96.8848 11.6477 96.6202 11.8997C96.3557 12.1517 95.9714 12.2776 95.4673 12.2776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1221 12.1925L100.763 8.46606H102.007L103.648 12.1925H102.34L101.128 9.06229H101.621L100.409 12.1925H99.1221ZM100.098 11.543L100.42 10.638H102.146L102.468 11.543H100.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3116 18.0483L81.2419 16.6695L82.6576 15.1204H84.0357L82.4484 16.8558L81.746 17.5691L81.3116 18.0483ZM80.1801 18.8468V15.1204H81.4242V18.8468H80.1801ZM82.6468 18.8468L81.5422 17.3988L82.3626 16.5364L84.1108 18.8468H82.6468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6953 18.8468L87.3362 15.1204H88.5802L90.2211 18.8468H88.9127L87.7008 15.7166H88.1941L86.9823 18.8468H85.6953ZM86.6712 18.1973L86.993 17.2923H88.7197L89.0414 18.1973H86.6712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.434 18.8468V15.1204H93.4743L94.9757 17.5532H94.4288L95.8873 15.1204H96.9276L96.9383 18.8468H95.7854L95.7747 16.8452H95.957L94.9596 18.5114H94.402L93.3617 16.8452H93.5869V18.8468H92.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.357 18.9319C100.782 18.9319 100.333 18.7776 100.012 18.4688C99.6898 18.16 99.5289 17.7271 99.5289 17.1699V15.1204H100.794V17.1326C100.794 17.4165 100.846 17.6188 100.95 17.7395C101.054 17.8566 101.193 17.9152 101.368 17.9152C101.547 17.9152 101.686 17.8566 101.786 17.7395C101.89 17.6188 101.942 17.4165 101.942 17.1326V15.1204H103.186V17.1699C103.186 17.7271 103.025 18.16 102.703 18.4688C102.382 18.7776 101.933 18.9319 101.357 18.9319Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 7.22812,
    y: 34.3008,
    width: 153.015,
    height: 21.5685,
    rx: 2.44172,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9594 47.4987V40.9971H77.651V47.4987H76.9594ZM77.2084 46.7517C76.821 46.7517 76.4499 46.701 76.0948 46.5995C75.7397 46.4935 75.4539 46.3575 75.2371 46.1915L75.6176 45.3476C75.825 45.4952 76.0694 45.6174 76.3507 45.7142C76.6366 45.8064 76.9248 45.8525 77.2153 45.8525C77.4366 45.8525 77.6142 45.8318 77.7479 45.7903C77.8862 45.7442 77.9877 45.6819 78.0522 45.6035C78.1168 45.5252 78.149 45.4352 78.149 45.3338C78.149 45.2047 78.0983 45.1032 77.9969 45.0295C77.8954 44.9511 77.7617 44.8888 77.5957 44.8427C77.4297 44.792 77.2453 44.7459 77.0424 44.7044C76.8441 44.6583 76.6435 44.6029 76.4406 44.5384C76.2424 44.4738 76.0602 44.3908 75.8942 44.2894C75.7282 44.1879 75.5922 44.0542 75.4861 43.8882C75.3847 43.7222 75.334 43.5101 75.334 43.2519C75.334 42.9752 75.4077 42.7239 75.5553 42.498C75.7075 42.2674 75.9334 42.0853 76.2331 41.9516C76.5375 41.8132 76.9179 41.7441 77.3744 41.7441C77.6787 41.7441 77.9784 41.7809 78.2735 41.8547C78.5686 41.9239 78.8292 42.0299 79.0551 42.1729L78.7093 43.0236C78.4833 42.8945 78.2574 42.8 78.0315 42.7401C77.8055 42.6755 77.5842 42.6432 77.3675 42.6432C77.1507 42.6432 76.9732 42.6686 76.8349 42.7193C76.6965 42.77 76.5974 42.8369 76.5375 42.9199C76.4775 42.9983 76.4475 43.0905 76.4475 43.1966C76.4475 43.3211 76.4983 43.4225 76.5997 43.5009C76.7012 43.5747 76.8349 43.6346 77.0009 43.6807C77.1669 43.7268 77.349 43.7729 77.5473 43.819C77.7502 43.8652 77.9508 43.9182 78.149 43.9781C78.3519 44.0381 78.5364 44.1188 78.7024 44.2202C78.8684 44.3217 79.0021 44.4554 79.1035 44.6214C79.2096 44.7874 79.2626 44.9972 79.2626 45.2508C79.2626 45.5228 79.1865 45.7718 79.0344 45.9978C78.8822 46.2237 78.654 46.4059 78.3496 46.5442C78.0499 46.6825 77.6695 46.7517 77.2084 46.7517ZM81.3701 46.7517C81.0335 46.7517 80.6992 46.7079 80.3672 46.6203C80.0398 46.5281 79.7585 46.399 79.5233 46.233L79.966 45.3753C80.1504 45.509 80.3626 45.6151 80.6023 45.6935C80.8467 45.7718 81.0934 45.811 81.3424 45.811C81.6237 45.811 81.845 45.7557 82.0064 45.645C82.1678 45.5344 82.2485 45.3799 82.2485 45.1816C82.2485 45.0571 82.2162 44.9465 82.1517 44.8496C82.0871 44.7528 81.9718 44.679 81.8058 44.6283C81.6444 44.5776 81.4162 44.5522 81.1211 44.5522H79.883L80.132 41.8271H83.0854V42.7262H80.5332L81.1142 42.2144L80.9413 44.158L80.3603 43.6461H81.3839C81.8635 43.6461 82.2485 43.713 82.539 43.8467C82.8341 43.9758 83.0485 44.1534 83.1822 44.3793C83.316 44.6052 83.3828 44.8612 83.3828 45.147C83.3828 45.4329 83.3114 45.6981 83.1684 45.9425C83.0255 46.1822 82.8041 46.3782 82.5044 46.5304C82.2093 46.6779 81.8312 46.7517 81.3701 46.7517ZM85.9124 46.7517C85.5159 46.7517 85.1608 46.6549 84.8473 46.4612C84.5337 46.2629 84.287 45.977 84.1072 45.6035C83.9273 45.23 83.8374 44.7782 83.8374 44.2479C83.8374 43.7176 83.9273 43.2657 84.1072 42.8922C84.287 42.5187 84.5337 42.2351 84.8473 42.0415C85.1608 41.8432 85.5159 41.7441 85.9124 41.7441C86.3136 41.7441 86.6686 41.8432 86.9776 42.0415C87.2911 42.2351 87.5378 42.5187 87.7177 42.8922C87.8975 43.2657 87.9874 43.7176 87.9874 44.2479C87.9874 44.7782 87.8975 45.23 87.7177 45.6035C87.5378 45.977 87.2911 46.2629 86.9776 46.4612C86.6686 46.6549 86.3136 46.7517 85.9124 46.7517ZM85.9124 45.8041C86.1015 45.8041 86.2652 45.7511 86.4035 45.645C86.5464 45.539 86.6571 45.3707 86.7355 45.1401C86.8185 44.9096 86.86 44.6122 86.86 44.2479C86.86 43.8836 86.8185 43.5862 86.7355 43.3556C86.6571 43.1251 86.5464 42.9568 86.4035 42.8507C86.2652 42.7447 86.1015 42.6916 85.9124 42.6916C85.728 42.6916 85.5643 42.7447 85.4213 42.8507C85.283 42.9568 85.1723 43.1251 85.0893 43.3556C85.011 43.5862 84.9718 43.8836 84.9718 44.2479C84.9718 44.6122 85.011 44.9096 85.0893 45.1401C85.1723 45.3707 85.283 45.539 85.4213 45.645C85.5643 45.7511 85.728 45.8041 85.9124 45.8041ZM90.6068 46.7517C90.2103 46.7517 89.8552 46.6549 89.5417 46.4612C89.2281 46.2629 88.9814 45.977 88.8016 45.6035C88.6217 45.23 88.5318 44.7782 88.5318 44.2479C88.5318 43.7176 88.6217 43.2657 88.8016 42.8922C88.9814 42.5187 89.2281 42.2351 89.5417 42.0415C89.8552 41.8432 90.2103 41.7441 90.6068 41.7441C91.008 41.7441 91.363 41.8432 91.672 42.0415C91.9855 42.2351 92.2322 42.5187 92.4121 42.8922C92.5919 43.2657 92.6818 43.7176 92.6818 44.2479C92.6818 44.7782 92.5919 45.23 92.4121 45.6035C92.2322 45.977 91.9855 46.2629 91.672 46.4612C91.363 46.6549 91.008 46.7517 90.6068 46.7517ZM90.6068 45.8041C90.7959 45.8041 90.9596 45.7511 91.0979 45.645C91.2408 45.539 91.3515 45.3707 91.4299 45.1401C91.5129 44.9096 91.5544 44.6122 91.5544 44.2479C91.5544 43.8836 91.5129 43.5862 91.4299 43.3556C91.3515 43.1251 91.2408 42.9568 91.0979 42.8507C90.9596 42.7447 90.7959 42.6916 90.6068 42.6916C90.4224 42.6916 90.2587 42.7447 90.1157 42.8507C89.9774 42.9568 89.8667 43.1251 89.7837 43.3556C89.7053 43.5862 89.6662 43.8836 89.6662 44.2479C89.6662 44.6122 89.7053 44.9096 89.7837 45.1401C89.8667 45.3707 89.9774 45.539 90.1157 45.645C90.2587 45.7511 90.4224 45.8041 90.6068 45.8041Z",
    fill: "#4254EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_411_17441",
    x1: 70.5117,
    y1: 6.99855,
    x2: 66.2286,
    y2: 14.9445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6DFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#90D4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744792,
    stopColor: "#76CEF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AC8FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_411_17441",
    x1: 73.2971,
    y1: 14.4841,
    x2: 66.3686,
    y2: 18.2683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AC8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0666667,
    stopColor: "#5BC8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133333,
    stopColor: "#5DC9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#60CAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266667,
    stopColor: "#65CBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#6BCCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#72CEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466667,
    stopColor: "#7BD1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533333,
    stopColor: "#83D3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8BD5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#93D7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733333,
    stopColor: "#99D8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#9EDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866667,
    stopColor: "#A1DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933333,
    stopColor: "#A3DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4DBFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_411_17441"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.717102,
    y: 0.116699,
    width: 166.037,
    height: 62.2639,
    rx: 2.44172,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_411_17441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.8636,
    height: 14.1996,
    fill: "white",
    transform: "translate(62.9805 6.67188)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_411_17441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.5591,
    height: 14.3532,
    fill: "white",
    transform: "translate(63.8775 6.67188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.33a1de8e84191c978a42c7169f1177da.svg";
export { ForwardRef as ReactComponent };